import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useSpaceSettlementHistory(spaceId: string, offset: number) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  return useSWR(userId ? ['space-settlements', userId, spaceId, offset] : null,
    () => fetch((token) => spacesApi.settlementHistory(token, spaceId, offset)),
    { ...VOLATILE_SWR_OPTIONS, shouldRetryOnError: false });
}
